import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import FavoriteStreamsCard from "../components/Card/FavoriteStreamsCard";
import { Link } from "react-router-dom";
import { decodeHtml } from "../lib/helper";
// import { decodeHtml } from "../../lib/helper";

const RecentVideos = ({ church }) => {
  const getRandomRecentVideos = () => {
    return church.streams.slice(1, 4);
  };

  return (
    <div className="flex flex-col items-start mx-auto px-2 md:px-4">
      <div className="py-4">
        <h2 className="text-xl font-semibold">Recent Videos</h2>
      </div>
      <div className="flex flex-col items-center hide-scroll-bar">
        {getRandomRecentVideos().map((stream, idx) => {
          return (
            <div className="py-1 w-full">
              <Link
                to={{
                  pathname: `/church/${church.id}?v=${stream.videoId}`,
                }}
                key={stream.id}
                className="flex flex-col items-center bg-white border rounded-lg shadow-md md:flex-row md:max-w-xl hover:bg-gray-100"
              >
                <img
                  className="object-cover w-full rounded-t-lg h-96 md:h-auto md:w-48 md:rounded-none md:rounded-l-lg"
                  src={stream.thumbnail}
                  alt={decodeHtml(stream.streamTitle)}
                />
                <div className="flex flex-col justify-between p-4 leading-normal">
                  <h5 className="mb-2 text-lg font-bold tracking-tight text-gray-900 text-ellipsis overflow-hidden ...">
                    {stream.streamTitle}
                  </h5>
                  <p className="mb-3 font-normal text-gray-700">
                    {stream.channelTitle}
                  </p>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentVideos;
